module.exports = __webpack_public_path__ + "img/cro-like.83255770.png";